/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getMatches.defs.js'
export * as $defs from './getMatches.defs.js'
